// extracted by mini-css-extract-plugin
module.exports = {"close":"MapButtonActionForAside_close__nGGmW"};